import * as React from 'react';
import { Layout, Menu, Dropdown, Icon, Avatar, Button, Popover, AutoComplete, message } from 'antd';
import service from '../service/apolloclient.service';
import '../css/Main.scss';
import Dashboard from './Dashboard';
import ActivityTable from './ActivityTable';
import Profiles from './Profiles';
import Tests from './Tests';
import Users from './Users';
import Reports from './reports';
// import Notifications from './Notifications';
import Organizations from './Organizations';
import Constants from './common/constants';
import { Redirect, Link } from 'react-router-dom';
import { staticProperties, STATICKEYS }  from './common/staticProperties';
import Auth from './common/auth';
import { Tasks } from './common/auth';
import LocalStorage from '../service/localstorage';
// import { historyNotifier } from './common/historyNotifier';
import { Route } from 'react-router-dom';
import ExternalDashboard from './external/Dashboard';
import { LOGGEDINUSERTYPE } from './common/constants';
import AutocompleteOrgs from './common/autocompleteOrgs';
import Employee from './Employees';
import AuditLog from './AuditLog';
import strings from '../eyeguide-localization/strings.main';
import Customer from './Customers';
import Token from './common/token';
import Settings from './Settings';

const userIcon = require('../images/illustration-profile.png');
const storage = new LocalStorage();
const logow = require('../images/logo.png');
const logos = require('../images/logo_eye.png');
const { SubMenu } = Menu;
const { Header, Sider, Content } = Layout;
const Option = AutoComplete.Option;
const OptGroup = AutoComplete.OptGroup;
const VIEWSTATE = {
  HOME: 'home',
  ROSTER: 'profile',
  USER: 'user',
  TEST: 'test',
  NOTIFICATION: 'notification',
  ORGANIZATION: 'organization',
  LOGOUT: 'logout',
  EXTERNALHOME: 'externalhome',
  DASHBOARD: '/dashboard',
  EMPLOYEE: '/employee',
  AUDIT: '/audit',
  CUSTOMER: '/customer',
  REPORTS: '/reports'
};

interface ImainState {
    collapsed: boolean;
    error: boolean;
    firstname: string;
    lastname: string;
    organization: string;
    viewstate: string;
    organizations: any;
    selectedOrganizationId: string;
    selectedOrganizationName: string;
    enableTitlePaneInContent: boolean;
    logo: any;
    profileListType: any;
    profieNavigateFrom: string;
    redirectPage: boolean;
    canViewUser: boolean;
    canViewTestReports: boolean;
    canViewOrg: boolean;
    selectedKey: any;
    isExternalLogin: boolean;
    openKey: any;
    noActiveOrg: boolean;
    content: any;
    popVisible: boolean;
    isNoOrg: boolean;
    isOrgSpecific: boolean;
    hideSideOpts: boolean;
    isFocusUser: boolean;
    showOnlySelOrg: boolean;
    allOrgs: any;
    canViewEmployee: boolean;
    canViewReports: boolean;
    canViewShareAudit: boolean;
    canViewCustomer: boolean;
    refresh: boolean;
  }

class Main extends React.Component<any, ImainState> {
      menu: any;
      orgMap: any;
      constructor(props: React.ReactPropTypes) {
        
        super(props);
        let roleid: any = storage.getToken() !== '' ? parseInt(Token.decodeToken().roleid, 10) : '';
        this.state = {
          collapsed: false,
          error : false,
          firstname: '',
          lastname: '',
          organization: '',
          viewstate: VIEWSTATE.HOME,
          organizations: [],
          selectedOrganizationId: '',
          selectedOrganizationName: '',
          enableTitlePaneInContent: false,
          logo: logow,
          profileListType: Constants.getProfileListTypes().DEFAULT,
          profieNavigateFrom: strings.lsHomeTxt,
          redirectPage: false,
          canViewOrg: false,
          canViewUser: false,
          canViewTestReports: false,
          selectedKey: VIEWSTATE.HOME,
          isExternalLogin: false,
          openKey: [VIEWSTATE.HOME],
          noActiveOrg: false,
          content: '',
          popVisible: false,
          isNoOrg: Auth.canPerformTask(roleid, Tasks.isNoOrg),
          isOrgSpecific: false,
          hideSideOpts: Auth.canPerformTask(roleid, Tasks.isNoOrg),
          isFocusUser: Auth.canPerformTask(roleid, Tasks.isFocusUser),
          showOnlySelOrg: Auth.canPerformTask(roleid, Tasks.showOnlySelOrg),
          canViewEmployee: Auth.canPerformTask(roleid, Tasks.canViewEmployee),
          canViewReports: Auth.canPerformTask(roleid, Tasks.canViewReports),
          canViewShareAudit: Auth.canPerformTask(roleid, Tasks.canViewShareAudit),
          canViewCustomer: Auth.canPerformTask(roleid, Tasks.canViewCustomer),
          allOrgs: [],
          refresh: false
        };
        this.setTitlePaneRequired = this.setTitlePaneRequired.bind(this);
        this.onBackButtonEvent = this.onBackButtonEvent.bind(this);
        this.showDashboard = this.showDashboard.bind(this);
        this.setSelectedOrg = this.setSelectedOrg.bind(this);
        // this.getCompState = this.getCompState.bind(this);
        // this.setCompState = this.setCompState.bind(this);
        this.refreshSidePane = this.refreshSidePane.bind(this);
        this.menuClicked = this.menuClicked.bind(this);
        this.handelStaticKeyChange = this.handelStaticKeyChange.bind(this);
        this.refreshLoginAsList = this.refreshLoginAsList.bind(this);
        staticProperties.addEventListener('Main', this.handelStaticKeyChange);
        this.menu = (
          <Menu mode="inline" onClick={({key}) => this.updateLogoutTime({key})}>
            <Menu.Item>
                <Link to={'/settings'}>
                <Icon type="setting" />
                    <span> {strings.lsSettingsTxt}</span>
                </Link>  
            </Menu.Item>
            <Menu.Item key={VIEWSTATE.LOGOUT}>
                <Icon type="logout" />
                    <span> {strings.lsLogOutTxt}</span>
            </Menu.Item>
        </Menu>
        );

        // historyNotifier.addEventListener('Main', this.getCompState, this.setCompState);
    }

    setTitlePaneRequired(titleRequired: boolean) {
      this.setState({
        enableTitlePaneInContent: titleRequired
      });
    }
    
    toggle = () => {      
      this.setState({      
        collapsed: !this.state.collapsed,      
        logo: this.changeLogo(!this.state.collapsed)
      });  
    }

    /*openHelpCenter = () => { // open helpcenter in new tab
      return window.open('/zendesklogin', '_blank');
    }*/

    async componentDidMount() {
      if (window.innerWidth <= 1280) {
        this.setState({
          collapsed: !this.state.collapsed,
          logo: this.changeLogo(!this.state.collapsed)
        });
      }
      document.title = `EyeGuide`;
      console.log('component Did Mount Main called');
      let ser = new service();
      let roleid: any = storage.getToken() !== '' ? parseInt(Token.decodeToken().roleid, 10) : '';
      let isExternalLogin = this.props.match.path.indexOf('external') !== -1 ;
      console.log(this.props.match.path.indexOf('external') !== -1);
      try {
        if (isExternalLogin) {
          this.setState({
            isExternalLogin,
            viewstate: VIEWSTATE.EXTERNALHOME,
            selectedKey: VIEWSTATE.EXTERNALHOME
          });
        } else {
          console.log('calling getorg main');
          let openKey: any;
          let selectedKey: any;
          let content: any;
          let res: any = [];
          let resp: any = [];
          if (!this.state.isNoOrg) {
            let allOrgs: any = await ser.getOrganizations();
            let uid = storage.getUid();
            let unchecked: any = await ser.getUncheckedOrgs(uid);
            console.log('unchecked', unchecked);
            allOrgs.forEach((e: any) => {
              let x = unchecked.filter(org => e.organizationid === org.organizationid);
              if (x.length === 0) { res.push(e); }
            });
            if (res.length === 0) {
              console.log('empty ');
              this.setState({noActiveOrg: true});
            }
            if (this.ifRouteExists(this.props)) {
              selectedKey = VIEWSTATE.HOME;
            } else {
              selectedKey = staticProperties.get(STATICKEYS.selectedKey);
              if (selectedKey.endsWith(VIEWSTATE.ROSTER) || selectedKey.endsWith(VIEWSTATE.TEST)) { 
                let rosterid = staticProperties.get(STATICKEYS.selectedRoster);
                if (rosterid !== '') {
                  openKey = ['rosters', rosterid];
                }
              }
            } 
          } else {
              resp = await ser.getAllOrganizations(Constants.getActivitBit().ACTIVE);
              console.log('res', resp);
              if (this.state.showOnlySelOrg) {
                console.log('single', storage.getSelectedOrg());
                res = await ser.getOrganization(storage.getSelectedOrg());
                res = [res];
                console.log('single res', res);
              } else {
                res = await this.getSubOrganization();
              }
              let sortOrgs = this.SortAllOrganization(resp);
              let opts: any = [(
              <OptGroup
                  key={'group'}
                  label={this.renderTitle('')}
              >
                {sortOrgs.map(opt => (
                <Option key={opt.organizationid} value={opt.organizationid}>
                  {opt.isprimary ? opt.name : '-- ' + opt.name}
              </Option>
              ))}
              </OptGroup>
              )];
                  // let opts: any = res;
              content = (
                    <AutocompleteOrgs
                          options={opts}
                          showDashboard={this.showDashboard}
                          orgMap={this.orgMap}
                    />
              );
              if (this.ifRouteExists(this.props)) {
                selectedKey = VIEWSTATE.HOME;
              } else {
                selectedKey = staticProperties.get(STATICKEYS.selectedKey);
                if (selectedKey.startsWith(VIEWSTATE.ROSTER) !== -1) { 
                  let rosterid = staticProperties.get(STATICKEYS.selectedRoster);
                  if (rosterid !== '') {
                    openKey = ['rosters', rosterid];
                  }
                }
              } 
          }
          this.setState({
            error: false,
            firstname: storage.getFirstName(),
            lastname: storage.getLastName(),
            organization: storage.getOrganizationName(),
            organizations: res,
            canViewUser: Auth.canPerformTask(roleid, Tasks.canViewUser) && !this.state.noActiveOrg,
            canViewTestReports: Auth.canPerformTask(roleid, Tasks.canViewTestReports) && !this.state.noActiveOrg,
            canViewOrg: Auth.canPerformTask(roleid, Tasks.canViewSubOrganization) && !this.state.noActiveOrg,
            isExternalLogin,
            selectedKey,
            openKey,
            content,
            hideSideOpts: storage.getSelectedOrg() === '',
            allOrgs: resp
          });
          if (res.length > 0) {
              this.sortOrganizations(res);
          }       
        }       
        // historyNotifier.pushstate('/home', 'Focusapp'); 

      } catch ( e ) {
        console.log('Error', e);
        this.setState({
          error: true,
          isExternalLogin
        });
      }
    }

    renderTitle(title: string) {
      return (
        <span>
          {title}
        </span>
      );
    }

    async updateLogoutTime(key: any) {
      console.log(key);
      if (key.key === VIEWSTATE.LOGOUT) {
        let ser = new service();
        let resp = await ser.updateLogoutTime();
        console.log('Logout Response', resp);
        window.location.href = '/login';
      }
    }

    onBackButtonEvent(e: any) {
      console.log('back clicked', e);
      console.log('clicked for?', e.currentTarget.location.pathname);
      console.log('current state', e.state);
    }

    render() {
      console.log('this.props', this.props);
      let isExternalLogin = this.props.match.path.indexOf('external') !== -1;
      let token = storage.getToken();
      console.log('storage.getSelectedOrg()', typeof(storage.getSelectedOrg()));
      console.log('storage', storage.getSelectedOrg() !== '' ? storage.getSelectedOrg().toString().split(',')
                : storage.getSelectedOrg());

      console.log('viewstate: ', this.state.viewstate);
      // console.log('Main token: ', token);
      if (this.state.viewstate === VIEWSTATE.LOGOUT || token.length === 0
        || ( token.length > 0 && !this.tokenIsValid(isExternalLogin, token))
      ) {
        if (isExternalLogin) {
          return ( 
                  <Redirect 
                      to={'/external/login/' + this.props.match.params.shareuserid + '/' + 
                            this.props.match.params.shareid}
                  /> 
                 );
        } else { return ( <Redirect to="/login" /> ); }
      }
      console.log('this.state.organization', this.state.organization);
      let orgName = this.state.isFocusUser ? strings.lsEyeGuideTxt : storage.getOrganizationName();
      console.log('orgId to dashboard', storage.getSelectedOrg().toString().split(',')[0]);
      return (
        <div className="Main">
        <Layout>
          <Sider
            trigger={null}
            collapsible={true}
            collapsed={this.state.collapsed}
            className={this.state.collapsed ? 'sidepaneS' : 'sidepaneB'}
          >
            <div className="logoContainer">
              <div className="logoD"> 
                <img className={this.state.collapsed ? 'logoS' : 'logoB'} src={this.state.logo} /> </div>
            </div>
            { this.state.isExternalLogin ? 
                        <Menu 
                          theme="dark" 
                          mode="inline" 
                          defaultSelectedKeys={[VIEWSTATE.EXTERNALHOME]} 
                          selectedKeys={[this.state.selectedKey]}
                        >
                            <Menu.Item key={VIEWSTATE.EXTERNALHOME} >
                                <Icon type="home"  />
                                <span>{strings.lsSharedDataTxt}</span>
                            </Menu.Item>
                        </Menu>
                          :
                          <Menu 
                            theme="dark" 
                            mode="inline" 
                            defaultSelectedKeys={[VIEWSTATE.HOME]} 
                            selectedKeys={[this.state.selectedKey]}
                            onSelect={e => console.log('onselectcalled')}
                            onOpenChange={e => this.menuOpenClicked(e)}
                            onClick={e => this.menuClicked(e)}
                            openKeys={this.state.openKey}
                          >
                            <Menu.Item key={VIEWSTATE.HOME} >
                            <Link to="/dashboard">
                                <Icon type="home"  />
                                <span>{strings.lsHomeTxt}</span>
                            </Link>
                            </Menu.Item>
                            { this.state.canViewCustomer && 
                                    this.state.hideSideOpts ?
                            <Menu.Item key={VIEWSTATE.CUSTOMER} >
                            <Link to="/customer">
                                <Icon type="team"  />
                                <span>{strings.lsCusTxt}</span>
                            </Link>
                            </Menu.Item>
                          : ''}
                          { this.state.canViewEmployee && 
                                    this.state.hideSideOpts ?
                            <Menu.Item key={VIEWSTATE.EMPLOYEE} >
                            <Link to="/employee">
                                <Icon type="team"  />
                                <span>{strings.lsEmpTxt}</span>
                            </Link>
                            </Menu.Item>
                          : ''}
                          { this.state.canViewReports && 
                                    this.state.hideSideOpts ?
                            <SubMenu 
                                key="reports" 
                                title={<span> 
                              <Icon type="file-text" /> 
                             <span> {strings.lsReportsTxt} </span>
                             </span>}
                            >
                              <Menu.Item key="report1" >
                              <Link to="">
                                  <Icon type="file-text"  />
                                  <span>{strings.lsReport1Txt}</span> 
                              </Link>
                              </Menu.Item>
                              <Menu.Item key="report2" >
                              <Link to="">
                                  <Icon type="file-text"  />
                                  <span>{strings.lsReport2Txt}</span> 
                              </Link>
                              </Menu.Item>
                            </SubMenu>
                          : ''}
                          { this.state.canViewShareAudit && 
                                    this.state.hideSideOpts ?
                            <Menu.Item key={VIEWSTATE.AUDIT} >
                            <Link to={VIEWSTATE.AUDIT}>
                                <Icon type="bars"  />
                                <span>{strings.lsAuditTxt}</span>
                            </Link>
                            </Menu.Item>
                          : ''}
                            {this.state.noActiveOrg || (this.state.isNoOrg && this.state.hideSideOpts)
                                                           ? '' : 
                            <SubMenu 
                              key="rosters" 
                              title={<span> 
                                     <Icon type="table" /> 
                                    <span> {
                                      (this.state.organizations.length > 1 ? strings.lsOrgsTxt : strings.lsOrgTxt)
                                            }
                                    </span>
                                    </span>}
                            >
                              {
                                this.state.organizations.map( (element: any) => {
                                  // tslint:disable-next-line:no-unused-expression
                                // tslint:disable-next-line:max-line-length

                                return (
                                <SubMenu 
                                          style={this.state.collapsed ? {
                                            width: '200px',
                                            overflow: 'hidden',
                                            'white-space': 'nowrap',
                                            'text-overflow': 'ellipsis'
                                          } : {}}
                                          key={element.rosterid} 
                                          title={element.isprimary === true ?
                                              <span >
                                              <span className="primary">* </span>
                                              {element.name}</span>
                                            : <span>{element.name}</span>
                                          }
                                >
                                <Menu.Item key={element.rosterid + VIEWSTATE.ROSTER}> 
                                  <Link 
                                    to={'/profile/' + this.getSelectedRosterID(element.organizationid)}
                                  >{strings.lsProfilesTxt}
                                  </Link> 
                                </Menu.Item>
                                <Menu.Item key={element.rosterid + VIEWSTATE.TEST}>
                                  <Link to={'/test/' + this.getSelectedRosterID(element.organizationid)}>
                                  {strings.lsTestTxt} </Link>  
                                </Menu.Item>
                                </SubMenu>);
                                })
                              }
                            </SubMenu>}
                            {this.state.canViewTestReports && (!this.state.isNoOrg || !this.state.hideSideOpts) 
                                ? <Menu.Item key={VIEWSTATE.REPORTS}>
                                <Link to={VIEWSTATE.REPORTS}>
                                  <Icon type="file-text" />
                                  <span>{strings.isReportTxt}</span>
                                </Link>
                            </Menu.Item> : null}
                            {this.state.canViewUser && (!this.state.isNoOrg || !this.state.hideSideOpts) 
                              ? <Menu.Item key={VIEWSTATE.USER}>
                                <Link to={'/user'}>
                                  <Icon type="team" />
                                  <span>{strings.lsManageUsrTxt}</span>
                                </Link>
                            </Menu.Item> : null}
                            {this.state.canViewOrg && (!this.state.isNoOrg || !this.state.hideSideOpts) 
                              ? <Menu.Item key={VIEWSTATE.ORGANIZATION}>
                              <Link to={'/organization'}>
                                <Icon type="shop" />
                                <span>{strings.lsManageOrgTxt}</span>
                              </Link>
                            </Menu.Item> : null}
                              {/* <Menu.Item key={VIEWSTATE.LOGOUT}>
                              <Link to={'/login'}>
                                <Icon type="logout" />
                                <span>Logout</span>
                              </Link>
                              </Menu.Item>  */}
                          </Menu> 
            }
          </Sider>
          <Layout id="layout" style={{overflowY : 'auto', height: '100vh'}}>
          
            <Header id="header" style={{ background: '#fff', padding: 0}}>           
              
              <div className="avatarContainer">

                <Icon
                  className="trigger"
                  type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
                  onClick={this.toggle}
                />

                 {!this.state.isExternalLogin ?                
                 
                  <div className="avatar">
                    {/* <Button
                        type="primary"
                        className="zendeskHelp"
                        onClick={() => this.openHelpCenter()}
                        style={{float: 'left'}}
                    >
                      <Icon type="question-circle" />
                      Help Center
                    </Button>  */}
                    <Dropdown className="userMenu" overlay={this.menu} placement="bottomRight">
                      <div style={{float: 'right'}}>
                        <Avatar 
                            src={userIcon}
                            style={{ backgroundColor: '#8B9FB2' }} 
                            icon="user" 
                        />                   
                        <div className="hDisplayName" >
                          <div>{'  ' + storage.getFirstName() + ' ' + storage.getLastName()}
                          </div>

                        </div> 
                        <div 
                          className="hOrgName"                      
                          title={orgName}                
                        >{'  ' + orgName}
                        </div>
                      </div>
                    </Dropdown>
                  </div> 
                  : ''}

              {this.state.isNoOrg && !this.state.hideSideOpts ?
                
                <Button 
                  onClick={() => this.logoutFromOrg()} 
                  className="btnLogout"
                >
                  <div 
                    className="tooltip"
                    title={storage.getSelectedOrgName()}
                  > {strings.lsLogoutFromTxt} {storage.getSelectedOrgName()}
                  </div>
                </Button> :
              this.state.isNoOrg && this.state.hideSideOpts && !this.state.isExternalLogin ?

            <Popover 
              content={this.state.content} 
              overlayStyle={{width: '400px'}}
              // getPopupContainer={this.getContainer}
              title={<div>{strings.lsSelectOrgtxt} 
                      <Button 
                        icon="close" 
                        size="small" 
                        style={{border: 'none', float: 'right'}} 
                        onClick={() => this.setState({popVisible: false})}
                      /> 
                    </div>}
              trigger="click"
              visible={this.state.popVisible}
              
            >
              <Button onClick={() => this.setState({popVisible: true})} className="btnLoginAs">
                  {strings.lsLoginAsTxt}
              </Button>

            </Popover>

                  : ''}
              </div>
            </Header>
       
            <Content 
              className={this.state.enableTitlePaneInContent ? 'contentWithTitle' : 'contentWithoutTitle'}
              style={{margin: '0'}}
            >

                <Route
                    path={'/external/home/' + ':shareuserid/:shareid'} 
                    render={(props: any) => 
                    <ExternalDashboard
                      {...props}
                      shareuserid={this.props.match.params.shareuserid}
                    />
                    }
                />
                <Route 
                  path={'/settings'}
                  render={(props: any) => 
                  <Settings 
                    refreshHeaderLayout={() => this.setState({refresh: !this.state.refresh})}
                  />
                  }
                />
                <Route
                    path={'/dashboard/:id/:count/:date1/:date2'}
                    render={(props) => <ActivityTable {...props} />}
                />
                <Route 
                    path={'/profile/' + ':rosterid'} 
                    render={(props: any) => 
                    <Profiles 
                      organizationID={this.state.selectedOrganizationId} 
                      rosterID={this.getSelectedRosterID('')}
                      organizationName={this.state.selectedOrganizationName}
                      enableTitleSpace={this.setTitlePaneRequired}
                      navigateFrom={this.state.profieNavigateFrom}
                      type={Constants.getProfileListTypes().DEFAULT}
                      {...props}
                    />                    
                  }
                />
                <Route 
                    path={'/dashboardprofile/baseline/:orgid?'} 
                    render={(props: any) => 
                    <Profiles 
                      organizationID={this.state.selectedOrganizationId} 
                      rosterID={this.getSelectedRosterID('')}
                      organizationName={this.state.selectedOrganizationName}
                      enableTitleSpace={this.setTitlePaneRequired}
                      navigateFrom={this.state.profieNavigateFrom}
                      type={Constants.getProfileListTypes().BASELINES_LAST_WEEK}
                      {...props}
                    />                    
                  }
                />
                <Route 
                    path={'/dashboardprofile/baselinepending/:orgid?'} 
                    render={(props: any) => 
                    <Profiles 
                      organizationID={this.state.selectedOrganizationId} 
                      rosterID={this.getSelectedRosterID('')}
                      organizationName={this.state.selectedOrganizationName}
                      enableTitleSpace={this.setTitlePaneRequired}
                      navigateFrom={this.state.profieNavigateFrom}
                      type={Constants.getProfileListTypes().BASELINES_PENDING}
                      {...props}
                    />                    
                  }
                />
                <Route 
                    path={'/dashboardprofile/impaired/:orgid?'} 
                    render={(props: any) => 
                    <Profiles 
                      organizationID={this.state.selectedOrganizationId} 
                      rosterID={this.getSelectedRosterID('')}
                      organizationName={this.state.selectedOrganizationName}
                      enableTitleSpace={this.setTitlePaneRequired}
                      navigateFrom={this.state.profieNavigateFrom}
                      type={Constants.getProfileListTypes().IMPAIRED_PROFILES}
                      {...props}
                    />                    
                  }
                />

                <Route 
                    path={'/test/' + ':rosterid'} 
                    render={(props: any) => 
                    <Tests 
                      organizationID={this.state.selectedOrganizationId} 
                      organizationName={this.state.selectedOrganizationName}
                      enableTitleSpace={this.setTitlePaneRequired}
                      {...props}
                    />                    
                  }
                />
                <Route 
                    path={'/dashboard'} 
                    render={(props: any) => 
                    <Dashboard
                      {...props}
                      firstname={storage.getFirstName()}
                      isOrgSpecific={storage.getSelectedOrg() === '' ? this.state.isOrgSpecific : true}
                      orgId={storage.getSelectedOrg().toString().split(',')[0]}
                      setSelectedOrg={this.setSelectedOrg}
                      
                    />                    
                  }
                />
                <Route 
                    path={'/user'} 
                    render={(props: any) => 
                    <Users
                      organizationID={this.state.selectedOrganizationId} 
                      rosterID={this.getSelectedRosterID('')}
                      organizationName={this.state.selectedOrganizationName}
                      enableTitleSpace={this.setTitlePaneRequired}
                      {...props}
                    />                    
                  }
                />
                <Route 
                    path={'/reports'} 
                    render={(props: any) => 
                    < Reports
                      organizationID={this.state.selectedOrganizationId} 
                      rosterID={this.getSelectedRosterID('')}
                      organizationName={this.state.selectedOrganizationName}
                      organizations={this.state.organizations}
                      {...props}
                    />                    
                  }
                />
                <Route 
                    path={'/employee'} 
                    render={(props: any) => 
                    <Employee 
                      {...props}
                    />                    
                  }
                />
                <Route 
                    path={'/customer'} 
                    render={(props: any) => 
                    <Customer 
                      notifyCustomerUpdate={this.refreshLoginAsList}
                      {...props}
                    />                    
                  }
                />
                                
                <Route 
                    path={VIEWSTATE.AUDIT} 
                    render={(props: any) => 
                    <AuditLog 
                      {...props}
                    />                    
                  }
                />
                <Route 
                    path={'/organization'} 
                    render={(props: any) => 
                    <Organizations 
                      organizationID={this.state.selectedOrganizationId} 
                      rosterID={this.getSelectedRosterID('')}
                      organizationName={this.state.selectedOrganizationName}
                      enableTitleSpace={this.setTitlePaneRequired}
                      navigateFrom={'Home'}
                      notifyOrgStatusChange={this.refreshSidePane}
                      {...props}
                    />                    
                  }
                />   
                   
            </Content>
          </Layout>
        </Layout>
        </div>
      );
    }

    /**
     * Changes the logo as per collapse status
     * @param collapsed
     */
    private changeLogo(collapsed: boolean) {
      if (collapsed) {
        return logos;
      } else {
        return logow;
      }
    }      

    /**
     * Returns the roster id using organization id
     * @param organizationID
     */
    private getSelectedRosterID(organizationID: any): string {
      let rosterid = 'home';
      this.state.organizations.forEach( (element: any) => {
        if ( element.organizationid === organizationID ) {
          rosterid = element.rosterid;
        } 
      });
      return rosterid;
    }

    /**
     * This function is called when any organization 's active status is changed to refresh the side pane.
     * Called from Organization component
     */
    private async refreshSidePane() {
      let ser = new service();
      console.log('calling getorg main refreshSidePane');
      let res: any;
      if (!this.state.isNoOrg) {
        res = await ser.getOrganizations();
        console.log('organizations');
        if (res.length === 0) {
          console.log('empty ');
          this.setState({
            organizations: res,
            noActiveOrg: true});
        } else {
          this.sortOrganizations(res);
        }
      } else {
          if (this.state.showOnlySelOrg) {
            console.log('single', storage.getSelectedOrg());
            res = await ser.getOrganization(storage.getSelectedOrg());
            res = [res];
            console.log('single res', res);
          } else {
            res = await this.getSubOrganization();
          }
          this.sortOrganizations(res);
      }
    }

    /**
     * Checks token validation
     * @param isExternal If External Login
     * @param token 
     */
    private tokenIsValid(isExternal: boolean, token: any) {
      let decodedToken: any = Token.decodeToken() ;
      if ( isExternal && decodedToken.user === LOGGEDINUSERTYPE.ExternalUser) {
        return true;
      } else if ( !isExternal && decodedToken.user === LOGGEDINUSERTYPE.InternaleUser) {
        return true;
      } else {
        return false;
      }
    }
    
    /**
     * Called when side menu is clicked
     * @param e Menu clicked
     */
    private menuClicked(e: any) {
      console.log('element', e); 
      staticProperties.set(STATICKEYS.rerender, true);
      this.setState({selectedKey: e.key});
    }

    /**
     * Checks the URL hit for other internal URL s
     * @param props Component Props
     */
    private ifRouteExists(props: any) {
        let exists = false;
        exists = props.location.pathname.startsWith(VIEWSTATE.DASHBOARD);
        return exists;
    }

    private menuOpenClicked(e: any) {
      console.log('menuOpened', e);
      this.setState({openKey: e});
    }

    private handelStaticKeyChange(key: any, value: any) {
      console.log('handelStaticKeyChange', value, key);
      if ( key === STATICKEYS.selectedKey && value !== '') {
        console.log('in handlestatic', ['rosters', value + '']);
        this.setSelectedKey();
      } else if ( key === STATICKEYS.organizationId ) {
        console.log('keyvalye', key + ' ' + value);
        if (this.state.isFocusUser) {
          let matched: boolean = false;
          if (value !== '') {
            let orgIds = storage.getSelectedOrg().toString().split(',');
            orgIds.indexOf(value) > -1 ? matched = true : matched = false;
            console.log('matched');
          }
          if (!matched) {
            message.error(strings.lsLoggedInErrTxt, 10);
            window.location.href = '/dashboard';
          }
        } 
      }
    }

    private setSelectedKey() {
      let isExternalLogin = this.props.match.path.indexOf('external') !== -1 ;
      let selectedKey: any ;
      let openKey: any ;
      if (isExternalLogin) {
        this.setState({
          isExternalLogin,
          viewstate: VIEWSTATE.EXTERNALHOME,
          selectedKey: VIEWSTATE.EXTERNALHOME
        });
      } else {
          if (this.ifRouteExists(this.props)) {
            selectedKey = VIEWSTATE.HOME;
          } else {
            selectedKey = staticProperties.get(STATICKEYS.selectedKey);
            if (selectedKey.endsWith(VIEWSTATE.ROSTER) || selectedKey.endsWith(VIEWSTATE.TEST)) { 
              let rosterid = staticProperties.get(STATICKEYS.selectedRoster);
              if (rosterid !== '') {
                openKey = ['rosters', rosterid];
              } else {
                openKey = ['rosters'];
              }
            } else {
              openKey = [];
            }
          }
          this.setState({
            selectedKey,
            openKey
          }); 
          console.log('openkey', openKey);
          console.log('selectedKey', selectedKey);
      }
    }

    private async showDashboard(obj: any) {
      try {
        var key: any = obj.key, value: any = obj.value;
        let orgs: any = [];
        var primaryOrgId: any = this.getPrimaryOrgId(key); console.log('showDashboard', key);
        if (this.state.showOnlySelOrg) {
          storage.setSelectedOrg(key);
        } else {
          orgs = await new service().getSubOrganizations(1, primaryOrgId); console.log('orgs', orgs);
          if (!orgs.length && orgs.message) {
            throw orgs.message;
          }
          storage.setSelectedOrg(this.getSubOrgId(orgs));
        }
        storage.setSelectedOrgPrimary(primaryOrgId);
        storage.setSelectedOrgName(value);
        this.setState({
          isOrgSpecific: true,
          popVisible: false,
        });
        this.sortOrganizations(orgs);
        console.log('location', this.props.location);
        if (this.props.location.pathname !== VIEWSTATE.DASHBOARD) {
          window.location.href = VIEWSTATE.DASHBOARD;
        }
      } catch (err) {
        message.error(err);
      }
    }

    private async getSubOrganization() {
      let orgs: any = [];
      let ser = new service();
      let primaryorgid = storage.getSelectedOrgPrimary();
      orgs = await ser.getSubOrganizations(1, storage.getSelectedOrgPrimary());
      console.log('orgs', orgs);
      if (primaryorgid !== '') {
        storage.setSelectedOrg(this.getSubOrgId(orgs));
      }
      return orgs;
    }

    private getSubOrgId(resp: any) {
      let subOrgId: any = [];
      let primeIndex = -1;
      resp.forEach((element, i) => {
        if (element.isprimary) {
          primeIndex = i;
        }
        subOrgId.push(element.organizationid);
      });
      if (primeIndex > 0) {
        let temp = subOrgId[0];
        subOrgId[0] = subOrgId[primeIndex];
        subOrgId[primeIndex] = temp;
      }
      console.log('getSubOrgId', subOrgId);
      return subOrgId;
    }

    private getPrimaryOrgId(key: any ) {
      let org: any = this.state.allOrgs.filter((e: any) => 
        e.organizationid === key
      );
      console.log('getPrimaryOrgId');
      return org.length > 0 ? org[0].primaryorganizationid : '';
    }

    // private getContainer = (triggernode) => {
    //   // debugger;
    //   console.log('getContainer', triggernode.parentNode);
    //   console.log('header', document.getElementById('header'));
    //   return document.getElementById('header') !== null ? document.getElementById('header')
    //      : triggernode.parentNode;
    // }

    private setSelectedOrg(orgs: any) {
      if (this.state.showOnlySelOrg) {
        console.log('setSelectedOrg', orgs);
        this.setState({
          hideSideOpts: false,
          organizations: orgs
        });
      } else {
        this.setState({
          hideSideOpts: false,
        });
      }
    }

    private logoutFromOrg() {
      storage.setSelectedOrg('');
      storage.setSelectedOrgName('');
      storage.setSelectedOrgPrimary('');
      window.location.href = '/dashboard' ;

      // this.setState({
      //   hideSideOpts: true,
      //   organizations: [],
      //   selectedOrgKey: undefined
      // });
    }

    private sortOrganizations(resOrgs: any) {
      console.log('resOrgs', resOrgs); 
      let orgs: any = [...resOrgs];
      let primeIndex: number = 0;
      let primeOrg = resOrgs.filter((e: any, index: number) => {
          if (e.isprimary === true) {
            primeIndex = index;
            return true;
          } else {
            return false;
          }

      });
      if (primeOrg.length > 0) {
        orgs.splice(primeIndex, 1);
        console.log('organization spliced ', orgs);
        orgs.unshift(primeOrg[0]);
        this.setState({
          organizations: orgs
        });
      } else {
        this.setState({
          organizations: orgs
        });
      }
      console.log('organization unshift ', this.state.organizations);
    }

    private async refreshLoginAsList() {
      console.log('refreshLoginAsList');
      let content: any;
      let ser = new service();
      let resp: any = await ser.getAllOrganizations(1);
      console.log('refreshLoginAsList', resp);
      let sortOrgs = this.SortAllOrganization(resp);
      let opts: any = [(
        <OptGroup
            key={'group'}
            label={this.renderTitle('')}
        >
        {sortOrgs.map(opt => (
        <Option key={opt.organizationid} value={opt.organizationid}>
          {opt.isprimary ? opt.name : '-- ' + opt.name}
        </Option>
        ))}
        </OptGroup>
      )];
      content = (
        <AutocompleteOrgs
              options={opts}
              showDashboard={this.showDashboard}
              orgMap={this.orgMap}
        />
      );
      this.setState({
        content,
        allOrgs: resp
      });
    }

    private SortAllOrganization(allOrgs: any) {
      console.log('');
      let sortedOrgs: any = this.sortNames(allOrgs);
      let orgMap = new Map();
      let primeOrgs: any = this.getPrimaryOrgs(sortedOrgs);
      
      let newOrgArray: any = [];
      primeOrgs.forEach((elem: any) => {  
        newOrgArray.push(elem);
        let subOrgs: any = [];
        sortedOrgs.forEach((e: any) => {
          if (!e.isprimary && elem.organizationid === e.primaryorganizationid ) {
            newOrgArray.push(e);
            subOrgs.push(e);
          }
        });
        orgMap.set(elem.name, subOrgs);
      });
      this.orgMap = orgMap;
      console.log('new org array', newOrgArray);
      return newOrgArray;
    }

    private getPrimaryOrgs(orgs: any) {
      let sortedOrgs = [...orgs];
      console.log('sortedOrgs', sortedOrgs);
      let primeOrgs = sortedOrgs.filter((e: any, index: number) => {
        if (e.isprimary === true) {
          return true;
        } 
        return false;
      });
      console.log('primeOrgs', primeOrgs);
      return primeOrgs;
    }
    
    private sortNames(orgs: any) {
      let sortOrgs: any = [...orgs];
      console.log('sortNames', sortOrgs.sort((a: any, b: any) => 
         a.name.localeCompare(b.name) ));
      return sortOrgs;
    }

  }

export default Main;


// WEBPACK FOOTER //
// ./src/components/Main.tsx